"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _default = function _default() {
  for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
    keys[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, actionCreatorArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      actionCreatorArgs[_key2] = arguments[_key2];
    }

    return keys.reduce(function (acc, key, idx) {
      return (0, _extends3.default)({}, acc, (0, _defineProperty2.default)({}, key, actionCreatorArgs[idx]));
    }, {});
  };
};

exports.default = _default;
module.exports = exports.default;